import { createSlice } from '@reduxjs/toolkit'

export const networkSlice = createSlice({
    name: 'network',
    initialState: {
        isOnline: typeof navigator !== 'undefined' ? navigator.onLine : true,
        isUnreliable: false,
    },
    reducers: {
        setOnline: (state, { payload }) => {
            state.isOnline = payload
        },
        setUnreliable: (state, { payload }) => {
            state.isUnreliable = payload
        },
    },
})

export const { setOnline, setUnreliable } = networkSlice.actions
export default networkSlice.reducer
